import React from "react";
import styled from "styled-components";
import { deviceMax } from "../../../styles/device";
import Colors from "../../constants/Colors";

const FaqButtons = ({filterItem, menuItems}: any) => {
    return (
        <React.Fragment>
            <FaqButtonsWrapper>
                <React.Fragment>
                    {menuItems.map((Val: any, id: any) => {
                        return (
                            <div key={id}>
                                <input type={"radio"} id={Val} name={"category"}
                                       value={Val}
                                       defaultChecked={Val === "GENEL"}
                                       onClick={() => filterItem(Val)}
                                       key={id}
                                />
                                <label htmlFor={Val}>{Val}</label>
                                <span className="checkmark"></span>
                            </div>
                        );
                    })}
                </React.Fragment>
            </FaqButtonsWrapper>
        </React.Fragment>
    );
};

const FaqButtonsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
  
    @media ${deviceMax.tablet} {
        grid-template-columns: repeat(1, 1fr);
    }

  > div {
    position: relative;
    display: block;
    cursor: pointer;
    user-select: none;
    width: fit-content !important;

    > label {
      display: block;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0;
      color: ${Colors.blackColor};
      padding-left: 41px;
      padding-top: 3px;
      cursor: pointer;
    }

    &:hover {
      input ~ .checkmark {
        background-color: #ccc;
      }
    }

    > input:checked ~ .checkmark {
      background-color: ${Colors.checkboxCheckColor};
    }

    > .checkmark:after {
      left: 10px;
      top: 7px;
      width: 5px;
      height: 10px;
      border: solid white;
      border-width: 0 2px 2px 0;
      -webkit-transform: rotate(35deg);
      -ms-transform: rotate(35deg);
      transform: rotate(35deg);
    }

    > input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 100%;
      width: 100%;
      margin: 0;
      z-index: 2;
    }

    > .checkmark {
      position: absolute;
      top: 0;
      left: 0;
      height: 29px;
      width: 29px;
      background-color: ${Colors.checkboxUncheckColor};
      border-radius: 50%;

      &:after {
        content: "";
        position: absolute;
        display: block;
      }
    }

    > .title {
      display: block;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0;
      color: ${Colors.blackColor};
      padding-left: 41px;
      padding-top: 3px;
    }
  }
`;

export default FaqButtons;
